<template>
  <div>
    <!-- <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="time"
        transition="scale-transition"
        max-width="290px"
        min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            dense
            outlined
            v-model="time"
            :label="label"
            readonly
            v-bind="attrs"
            v-on="on"
            v-on:change="val => $emit('change', val)"
        ></v-text-field>
      </template>
      <v-time-picker
          format="24hr"
          v-if="menu"
          v-model="time"
          full-width
          v-on:change="onChange"
      ></v-time-picker>
    </v-menu> -->

    <v-text-field
      dense
      outlined
      :label="label"
      v-model="time"
      type="time"
      v-on:change="val => $emit('change', val)"
    ></v-text-field>
  </div>

</template>

<script>
export default {
  name: 'TimePicker',
  props: {
    label: String,
    value: String
  },
  data: () => ({
    time: null,
    menu: false,
  }),
  mounted() {
    this.time = this.value
  },
  watch: {
    value: function(time) {
      this.time = time
    }
  },
  methods: {
    onChange(time) {
      this.time = time
      this.$refs.menu.save(time)
      this.$emit('change', time)
    }
  }
}
</script>

<style scoped>

</style>